<template>
  <div>

     <data-table
        table-ref="progress-table"

        title="Progress"
        icon="fa fa-share-alt"

        hide-org-badge
        show-search="false"

        :url="'/actions/site/' + rowData.id + '/null/prg'"

        :fields="fields"

       />
<!--
        :add-action="isManager('project|maintenance|finance|property|admin') ? action : null"
        :add-props="addProps"
-->
  </div>

</template>


<script>
import DateMixins from '@/mixins/DateMixins'
import NumberMixins from '@/mixins/NumberMixins'

export default {

  mixins: [DateMixins, NumberMixins],

  props: {
    rowData: {
      type: Object,
      required: true
    }
  },




  data () {

    return {

      fields: [
        {
          name: '__sequence',
          title: '#',
          sortField: 'id'
        },
        {
          name: 'actionType',
          title: 'Type',
          sortField: 'actionType',
        },
        {
          name: 'status',
          title: 'Status',
          sortField: 'status',
          titleClass: 'hidden-sm-and-down',
          dataClass: 'hidden-sm-and-down'
        },
        {
          name: 'priority',
          title: 'Priority',
          sortField: 'priority',
          callback: this.formatPriority,
          titleClass: 'hidden-md-and-down',
          dataClass: 'hidden-md-and-down'
        },
        {
          name: 'organisation.shortName',
          title: 'Company',
          titleClass: 'hidden-md-and-down',
          dataClass: 'hidden-md-and-down'
        },
        {
          name: 'targetDate',
          title: 'Target Date',
          callback: 'formatDate|DD MMM YYYY',
          titleClass: 'hidden-md-and-down',
          dataClass: 'hidden-md-and-down'
        }

      ]
    }

  }

}

</script>



// WEBPACK FOOTER //
// Progress.vue?1d3a998d